import { useContext } from 'react';
import { UsersTypeAccessContext } from 'contexts/UsersTypeAccessContext/UsersTypeAccessContext';
import { UsersTypeAccessContextType } from 'types/UsersTypeAccessType';

const useUsersTypeAccess = () => {
  return useContext<UsersTypeAccessContextType>(UsersTypeAccessContext as any);
};

export default useUsersTypeAccess;
